<h2 mat-dialog-title>Volatile Stock</h2>

<mat-dialog-content class="mat-typography">
  @if (loading) {
    <mat-spinner diameter="20" class="mt-3" />
  } @else {
    <div class="row">
      <mat-chip-listbox class="mb-3">
        <mat-chip-option selected (selectionChange)="changeSelection(null)">
          All ({{ overview.numberOfProducts }})
        </mat-chip-option>

        <mat-chip-option (selectionChange)="changeSelection('Overdue')">
          Overdue ({{ overview.numberOfOverdueProducts }})
        </mat-chip-option>

        <mat-chip-option (selectionChange)="changeSelection('Due')">
          Due ({{ overview.numberOfDueProducts }})
        </mat-chip-option>

        <mat-chip-option (selectionChange)="changeSelection('Expired')">
          Expired ({{ overview.numberOfExpiredProducts }})
        </mat-chip-option>

        <mat-chip-option (selectionChange)="changeSelection('Opened')">
          Opened ({{ overview.numberOfOpenedProducts }})
        </mat-chip-option>
      </mat-chip-listbox>
    </div>

    <div class="table-container mb-0">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
          <td mat-cell *matCellDef="let row">{{ formatStockAmount(row.amount, row.quantityUnit) }}</td>
        </ng-container>

        <ng-container matColumnDef="expiresAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Expires At</th>
          <td mat-cell *matCellDef="let row"><app-table-cell-date format="d MMM Y" [value]="row.expiresAt" /></td>
        </ng-container>

        <ng-container matColumnDef="locationName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="text-aligned-with-button">Location</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <app-entity-link-button [name]="row.locationName" [route]="links.locations.viewOne(row.locationId)" />
          </td>
        </ng-container>

        <ng-container matColumnDef="openedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Opened At</th>
          <td mat-cell *matCellDef="let row"><app-table-cell-date [value]="row.openedAt" /></td>
        </ng-container>

        <ng-container matColumnDef="productCategoryName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="text-aligned-with-button">Product Category</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <app-entity-link-button
              [name]="row.productCategoryName"
              [route]="links.productCategories.viewOne(row.productCategoryId)" />
          </td>
        </ng-container>

        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
          <td mat-cell *matCellDef="let row">
            {{ row.productName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="productGroupName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="text-aligned-with-button">Product Group</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <app-entity-link-button
              [name]="row.productGroupName"
              [route]="links.productGroups.viewOne(row.productGroupId)" />
          </td>
        </ng-container>

        <ng-container matColumnDef="purchasedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchased At</th>
          <td mat-cell *matCellDef="let row"><app-table-cell-date [value]="row.purchasedAt" /></td>
        </ng-container>

        <ng-container matColumnDef="useBefore">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Use Before</th>
          <td mat-cell *matCellDef="let row"><app-table-cell-date format="d MMM Y" [value]="row.useBefore" /></td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Value</th>
          <td mat-cell *matCellDef="let row">
            @if (row.value) {
              {{ row.value | svCurrency }}
            } @else {
              -
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns" [ngClass]="getCurrentStockColourClass(row)"></tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>
    <mat-icon>close</mat-icon>
    Close
  </button>
</mat-dialog-actions>
